import womanIllustration from '../assets/custom-dev-illustration.webp'; // grouped image
import illustration from "../assets/dev-illustration.webp"; // Replace with your image path
import centralGroup from "../assets/woman-grouped.webp"; // includes woman + 3 badges
import badgeReturn from "../assets/badge-return.png";
import badgeIntegration from "../assets/badge-integrate.png";
import badgeSupport from "../assets/badge-support.png";
import badgeUnique from "../assets/badge-unique.png";
import badgeScale from "../assets/badge-scale.png";
import badgeProductivity from "../assets/badge-productivity.png";
import { motion } from "framer-motion";
import underline from '../assets/underline.png'; 
import { useState, useEffect,useRef } from "react";
import inst from "../assets/Ins.png";
import face from "../assets/Face.png";
import you from "../assets/You.png";
import lin from "../assets/Lin.png";
import twi from "../assets/Twi.png";
import news from "../assets/News.png";
import phone from "../assets/phone.png";
import mail from "../assets/Mail.png";
import loc from "../assets/Loc.png";
import nlen from "../assets/Nlen.svg";
import user from "../assets/user.png";  
import { Link } from 'react-router-dom';
import dd from "../assets/DD.png";

import { Helmet } from "react-helmet";

import { useNavigate } from 'react-router-dom'; 
import { toast, ToastContainer } from "react-toastify";
 import efficiencyIcon from "../assets/efficiencyy.png";
import securityIcon from "../assets/security.png";
import integrationIcon from "../assets/integrationn.png";







export default function CustomDevelopmentSection() {
 

const fadeUpVariant = {
  hidden: { opacity: 0, y: 30 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};
   const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => {
    fetch("https://api.app.mawalog.com/v1.2/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
    }
  }, [data]);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };
 
   const canvasRef = useRef(null);
  const [captchaValue, setCaptchaValue] = useState(""); // text from API
  const [userCaptcha, setUserCaptcha] = useState("");
 
  /* ------------------------------------------------------------------- API fetch */
  const fetchCaptcha = async () => {
    try {
      const res = await fetch(
        "https://api.app.mawalog.com/v1.2/website"
      );
      const json = await res.json();
      setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
    } catch (err) {
      console.error("Error fetching captcha:", err);
    }
  };
 
  /* -- fetch once on mount ------------------------------------------------------- */
  useEffect(() => {
    fetchCaptcha();
  }, []);
 
  /* -- redraw every time captchaValue changes ------------------------------------ */
  useEffect(() => {
    if (!data) return; // nothing to paint yet
    const canvas = canvasRef.current;
    if (!canvas) return;
 
    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;
 
    /* ========= clear & background */
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);
 
    /* ========= random faint bezier curves (extra distortion) */
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.lineWidth = 1 + Math.random(); // 1-2 px
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.stroke();
    }
 
    /* ========= characters (uneven) */
    ctx.font = "bold 22px Arial";
    ctx.fillStyle = "#0A3A72";
    const chars = data.toString().split("");
 
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 0.8; // ±23°
      const x = 8 + i * 14 + (Math.random() * 4 - 2);
      const y = 22 + (Math.random() * 6 - 3);
 
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });
 
    /* ========= dots */
    for (let i = 0; i < 45; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [data]);
 
  /* -- reload button click ------------------------------------------------------- */
  // const handleReload = () => {
  //   fetch("https://api.app.mawalog.com/v1.2/website")
  //     .then((response) => response.json())
  //     .then((json) => {
  //       setData(json.data.captcha_code);
  //       setSessionid(json.data.session_id);
  //       setToken(json.data.token);
  //     })
  //     .catch((error) => console.error("Error fetching data:", error));
  // };
  //   const handleSubscribe = async () => {
  //   try {
  //     const response = await fetch(
  //       "https://api-uat.mawalog.com/admin/v2/api/newsletter",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "X-CSRF-TOKEN": token,
  //         },
  //         body: JSON.stringify({
  //           session_id: sessionid,
  //           captcha: userCaptcha,
  //           email: email,
  //           type: "Mawalog",
  //         }),
  //       }
  //     );
 
  //     const result = await response.json();
  //     console.log("Response:", userCaptcha, " ", data);
  //     setEmail("");
  //    setUserCaptcha("");
  //     toast(result.message);
  //   } catch (error) {
  //     console.error("Error sending request:", error);
  //   }
  // };
  const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };
  const navigate = useNavigate();
 
  const handleClick = () => {
    navigate("/Contact#contact-section");
  };
   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isServicesOpen, setIsServicesOpen] = useState(false);
    const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
    const [isCompanyOpen, setIsCompanyOpen] = useState(false);
  
    const toggleMobileMenu = () => {
      setIsMobileMenuOpen(!isMobileMenuOpen);
    };
  
    const toggleServicesDropdown = () => {
      setIsServicesOpen(!isServicesOpen);
    };
  
    const toggleIndustriesDropdown = () => {
      setIsIndustriesOpen(!isIndustriesOpen);
    };
  
    const toggleCompanyDropdown = () => {
      setIsCompanyOpen(!isCompanyOpen);
    };
  const floatingAnimation = {
  animate: {
    y: [0, -8, 0],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: "easeInOut",
    },
  },
};
  const badges = [
    { src: badgeReturn, alt: "Return Badge" },
    { src: badgeIntegration, alt: "Integrate Badge" },
    { src: badgeSupport, alt: "Support Badge" },
    { src: badgeUnique, alt: "Unique Badge" },
    { src: badgeScale, alt: "Scale Badge" },
    { src: badgeProductivity, alt: "Productivity Badge" },
  ];
 const featureData = [
  {
    icon: efficiencyIcon,
    title: "Efficiency",
    description:
      "With a custom solution, developers can analyze the places where things slow down",
  },
  {
    icon: securityIcon,
    title: "Security",
    description:
      "When they identify a vulnerability in a program, they can exploit it in multiple organizations",
  },
  {
    icon: integrationIcon,
    title: "Integration",
    description:
      "Easy integration is a feature that will dramatically increase the performance of a business.",
  },
];

const [isOpen, setIsOpen] = useState(false);

  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };
   // Newsletter captcha refs/state (separate)
  const [submail, setSubmail] = useState("");
  const newsletterCanvasRef = useRef(null);
  const [newsCaptcha, setNewsCaptcha] = useState("");
  const [newsletterCaptcha, setNewsletterCaptcha] = useState({ code: "", sessionId: "", token: "" });
  const [newsletterUserCaptcha, setNewsletterUserCaptcha] = useState(""); // <-- new state for newsletter captcha input
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  const handleReload = () => {
    fetchNewsletterCaptcha();
  };

  const fetchNewsletterCaptcha = async () => {
    try {
      const response = await fetch("https://api.app.mawalog.com/v1.2/website");
      const json = await response.json();
      if (json?.data) {
        setNewsletterCaptcha({ code: json.data.captcha_code, sessionId: json.data.session_id, token: json.data.token });
      }
    } catch (err) {
      console.error("Error fetching newsletter captcha:", err);
    }
  };

  useEffect(() => {
    // fetch both captchas on mount so both canvases are ready
    fetchNewsletterCaptcha();
  }, []);

  // Draw newsletter captcha whenever it changes
  useEffect(() => {
    if (!newsletterCaptcha?.code) return;
    const canvas = newsletterCanvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    // noise / curves
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.lineWidth = 1 + Math.random();
      ctx.stroke();
    }

    // draw characters
    const chars = newsletterCaptcha.code.toString().split("");
    ctx.fillStyle = "#0A3A72";
    const fonts = ["Arial", "Verdana", "Georgia", "Courier New", "Times New Roman"];
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 1.2;
      const x = 8 + i * 12 + (Math.random() * 4 - 2);
      const y = 24 + (Math.random() * 6 - 3);
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.font = `bold ${16 + Math.floor(Math.random() * 6)}px ${fonts[Math.floor(Math.random() * fonts.length)]}`;
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });

    // dots
    for (let i = 0; i < 35; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [newsletterCaptcha]);
   const handleSubscribe = async (e) => {
  e?.preventDefault?.();

  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!submail) {
    toast("Please enter an email address");
    return;
  }

  if (!emailRegex.test(submail)) {
    toast("Please enter a valid email address");
    return;
  }

  if (!newsletterUserCaptcha) {
    toast("Please enter the captcha");
    return;
  }

  try {
    const res = await fetch("https://api.app.mawalog.com/v1.2/newsletter", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": newsletterCaptcha.token || "", // use newsletter token
      },
      body: JSON.stringify({
        session_id: newsletterCaptcha.sessionId || "", // use newsletter session id
        captcha: newsletterUserCaptcha, // use newsletter captcha input
        email: submail,
        type: "Mawalog",
      }),
    });

    const result = await res.json();

    // On success clear inputs and reload captcha
    if (res.ok) {
      setSubmail("");
      setNewsletterUserCaptcha("");
      fetchNewsletterCaptcha();
    }

    toast(result.message || "Subscription response received");
  } catch (err) {
    console.error("Newsletter subscribe error:", err);
    toast("Subscription failed. Please try again.");
  }
};

  return (
    <>
   
 <Helmet>
        <title>Expert Software Consulting Services | Accelerate Digital Transformation</title>
        <meta name="description" content="Boost your business growth with expert software consulting. Our senior consultants provide strategic guidance, optimized systems, and flexible solutions for smarter decision-making and accelerated digital transformation."/>
        <meta name="keywords" content="IT strategy consulting, technology consulting, business technology solutions, software project management, software optimization, IT consulting experts, strategic software solutions"/>
      </Helmet>
    <section className="bg-white font-poppins overflow-hidden">
      <section className="bg-[#F8F8F8] font-poppins overflow-hidden">
  <div className="max-w-7xl mx-auto font-poppins px-6 py-20 grid grid-cols-12 items-center gap-8">
    {/* Left Content */}
    <motion.div 
      initial={{ opacity: 0, x: -40 }} 
      whileInView={{ opacity: 1, x: 0 }} 
      transition={{ duration: 0.8 }} 
      viewport={{ once: true }}
      className="col-span-12 md:col-span-6"
    >
      <p className="text-sm font-semibold font-poppins tracking-wider text-[#07862B] uppercase mb-4">
        Custom Development
      </p>
      <h2 className="text-4xl font-bold font-poppins text-black mb-6 leading-tight">
        Built exactly how <br /> you need it
      </h2>
      <p className="text-gray-700 text-base leading-relaxed max-w-lg">
        We build tailored software solutions designed to fit your unique business needs. From concept to launch, our expert developers deliver scalable, high-performance systems. Partner with us to turn your ideas into powerful, custom-built applications.
      </p>
    </motion.div>

    {/* Right Illustration */}
    <motion.div 
      initial={{ opacity: 0, scale: 0.9 }} 
      whileInView={{ opacity: 1, scale: 1 }} 
      transition={{ duration: 0.8, delay: 0.2 }} 
      viewport={{ once: true }}
      className="col-span-12 md:col-span-6 relative"
    >
      <img
        src={womanIllustration}
        alt="Custom development illustration"
        className="w-full max-w-[450px] mx-auto"
      />
    </motion.div>
  </div>

  {/* Overview Section */}
  <motion.section 
    initial={{ opacity: 0, y: 30 }} 
    whileInView={{ opacity: 1, y: 0 }} 
    transition={{ duration: 0.8 }} 
    viewport={{ once: true }}
    className="bg-[#07862B] text-white font-poppins py-10 px-4 sm:px-8 md:px-16 lg:px-24"
  >
    <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
      {/* Left Side */}
      <div className="relative">
        <h2 className="text-3xl sm:text-4xl font-bold uppercase">Overview</h2>
        <img
          src={underline}
          alt="underline"
          className="absolute left-0 bottom-[-10px] w-24 sm:w-28"
        />
      </div>

      {/* Right Side */}
      <p className="text-[16px] font-normal leading-relaxed text-[#FFFFFF] max-w-3xl">
  Development builds strategic partnerships, while business development drives client acquisition and growth. Software consulting and custom development provide expert, adaptive solutions across evolving industry needs.
</p>




    </div>
  </motion.section>

  {/* What is custom development */}
  <motion.section 
  initial={{ opacity: 0, y: 40 }} 
  whileInView={{ opacity: 1, y: 0 }} 
  transition={{ duration: 0.8, ease: "easeOut" }}
  viewport={{ once: true, amount: 0.4 }} // amount: how much needs to be visible
  className="w-full bg-white py-[80px] px-4 font-poppins"
>
  <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-[60px]">
    {/* Left: Image */}
    <div className="flex-shrink-0">
      <img
        src={illustration}
        alt="Custom Development Illustration"
        className="w-full max-w-[550px] object-contain"
      />
    </div>

    {/* Right: Text */}
    <div className="flex-1 text-left">
      <h2 className="text-[#1A1A1A] text-[40px] font-semibold leading-[52px] mb-3">
        What is custom<br />development?
      </h2>
      <div className="w-[48px] h-[2px] bg-[#2AA244] mb-6"></div>
      <p className="text-[#1A1A1A] text-[16px] leading-[28px] font-normal max-w-[540px]">
  Custom development is the process of creating software specifically designed to meet the unique needs of a business or industry. Unlike off-the-shelf solutions, it builds applications tailored to fit a company’s workflows, goals, and challenges. This approach offers greater flexibility, scalability, and efficiency.
</p>

    </div>
  </div>
</motion.section>
  
  
</section>

   <section className="relative bg-[#FCF5DC] font-poppins overflow-hidden py-20 px-4">
      {/* Heading */}
      <div className="text-center max-w-4xl mx-auto mb-16">
        <h2 className="text-[36px] sm:text-[42px] lg:text-[48px] font-bold text-[#1A1A1A] leading-tight mb-4">
          Advantages of custom <br className="hidden sm:block" /> development
        </h2>
        <p className="text-[#3D3D3D] text-[16px] leading-relaxed">
          It creates software tailored to a business’s unique needs and offers personalized
          <br className="hidden md:block" />
          solutions that evolve with changing requirements.
        </p>
      </div>

      {/* Mobile/Tablet: Grid layout */}
      <div className="block lg:hidden content-center max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6">
        {[badgeReturn, badgeIntegration, badgeSupport, badgeUnique, badgeScale, badgeProductivity].map((badge, idx) => (
          <motion.img
            key={idx}
            src={badge}
            alt={`Badge ${idx}`}
            className="w-[280px] sm:w-[300px]"
            animate={{ y: [0, -6, 0] }}
            transition={{
              repeat: Infinity,
              duration: 3 + idx * 0.1,
              ease: "easeInOut",
            }}
          />
        ))}
      </div>

      {/* Desktop: Absolute layout */}
      <div className="hidden lg:block relative w-full max-w-[1440px] min-h-[600px] mx-auto">
        {/* Central Group Image */}
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
          <img src={centralGroup} alt="Central Group" className="w-[590px] max-w-full" />
        </div>

        {/* Left Badges */}
        <motion.img
          src={badgeReturn}
          alt="Return"
          className="absolute left-[6%] top-[60px] w-[300px] xl:w-[360px]"
          animate={{ y: [0, -6, 0] }}
          transition={{ duration: 3.2, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.img
          src={badgeIntegration}
          alt="Integration"
          className="absolute left-[0%] top-[230px] w-[300px] xl:w-[360px]"
          animate={{ y: [0, -6, 0] }}
          transition={{ duration: 3.4, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.img
          src={badgeSupport}
          alt="Support"
          className="absolute left-[5%] bottom-[60px] w-[300px] xl:w-[360px]"
          animate={{ y: [0, -6, 0] }}
          transition={{ duration: 3.6, repeat: Infinity, ease: "easeInOut" }}
        />

        {/* Right Badges */}
        <motion.img
          src={badgeUnique}
          alt="Unique"
          className="absolute right-[6%] top-[60px] w-[300px] xl:w-[360px]"
          animate={{ y: [0, -6, 0] }}
          transition={{ duration: 3.1, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.img
          src={badgeScale}
          alt="Scale"
          className="absolute right-[4%] top-[230px] w-[300px] xl:w-[360px]"
          animate={{ y: [0, -6, 0] }}
          transition={{ duration: 3.3, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.img
          src={badgeProductivity}
          alt="Productivity"
          className="absolute right-[5%] bottom-[60px] w-[300px] xl:w-[360px]"
          animate={{ y: [0, -6, 0] }}
          transition={{ duration: 3.5, repeat: Infinity, ease: "easeInOut" }}
        />
      </div>
    </section>
<section className="w-full bg-white font-poppins py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-[1280px] mx-auto text-center mb-16">
        <h2 className="text-[36px] sm:text-[42px] lg:text-[48px] font-bold text-[#1A1A1A] leading-tight mb-4">
          Benefits of using custom <br className="hidden sm:block" />
          development
        </h2>
        <p className="text-[#333] text-lg max-w-[720px] mx-auto">
          Unlock the full potential of your business with powerful, tailor-made software solutions!
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
        {featureData.map((feature, index) => (
          <motion.div
            key={feature.title}
            custom={index}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={fadeUpVariant}
            className={`flex flex-col items-center text-center px-4 ${
              index < 2 ? "md:border-r md:border-gray-200" : ""
            }`}
          >
            <div className="mb-6 relative">
              <img
                src={feature.icon}
                alt={feature.title}
                className="w-[72px] h-[72px] object-contain relative z-10"
              />
              <div className="absolute top-2 left-2 w-14 h-14 bg-[#B8F6C8] rounded-full -z-0"></div>
            </div>
            <h3 className="text-xl font-semibold text-[#1A1A1A] mb-3">
              {feature.title}
            </h3>
            <p className="text-[#444] text-base leading-relaxed max-w-[300px]">
              {feature.description}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  

     
    </section>
     
       {isMobileMenuOpen && (
              <div className="lg:hidden bg-white border-t border-gray-100">
                <nav className="flex flex-col px-4 py-4 space-y-2 text-sm font-medium text-gray-800">
                  <div>
                    <button
                      className="flex items-center justify-between w-full text-black hover:text-black py-2"
                      onClick={toggleServicesDropdown}
                    >
                      Services
                      <img
                        src={dd}
                        alt="Dropdown arrow"
                        className={`h-1 w-2 transition-transform duration-300 ${
                          isServicesOpen ? 'rotate-180' : 'rotate-0'
                        }`}
                      />
                    </button>
                    {isServicesOpen && (
                      <div className="mt-2 space-y-1">
                        <Link
                          to="/services/ai-services/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Ai Services
                        </Link>
                        <Link
                          to="/services/web-development/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Web Development
                        </Link>
                        <Link
                          to="/services/mobile-app-development/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Mobile App Development
                        </Link>
                        <Link
                          to="/services/software-consulting/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Software Consulting
                        </Link>
                        <Link
                          to="/services/third-party-integration/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Third Party Integration
                        </Link>
                        <Link
                          to="/services/custom-development/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Custom Development
                        </Link>
                        <Link
                          to="/services/enterprise-application/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Enterprise Application
                        </Link>
                      </div>
                    )}
                  </div>
                  <div>
                    <button
                      className="flex items-center justify-between w-full text-black hover:text-black py-2"
                      onClick={toggleIndustriesDropdown}
                    >
                      Industries
                      <img
                        src={dd}
                        alt="Dropdown arrow"
                        className={`h-1 w-2 transition-transform duration-300 ${
                          isIndustriesOpen ? 'rotate-180' : 'rotate-0'
                        }`}
                      />
                    </button>
                    {isIndustriesOpen && (
                      <div className="mt-2 space-y-1">
                        <Link
                          to="/industries/digital-transformation/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Digital Transformation
                        </Link>
                        <Link
                          to="/industries/logistics/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Logistics
                        </Link>
                        <Link
                          to="/industries/healthcare/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Healthcare
                        </Link>
                        <Link
                          to="/industries/financial-services/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Financial Services
                        </Link>
                        <Link
                          to="/industries/education/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Education
                        </Link>
                        <Link
                          to="/industries/hospitality/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Hospitality
                        </Link>
                        <Link
                          to="/industries/entertainment/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Entertainment
                        </Link>
                      </div>
                    )}
                  </div>
                  <div>
                    <button
                      className="flex items-center justify-between w-full text-black hover:text-black py-2"
                      onClick={toggleCompanyDropdown}
                    >
                      Company
                      <img
                        src={dd}
                        alt="Dropdown arrow"
                        className={`h-1 w-2 transition-transform duration-300 ${
                          isCompanyOpen ? 'rotate-180' : 'rotate-0'
                        }`}
                      />
                    </button>
                    {isCompanyOpen && (
                      <div className="mt-2 space-y-1">
                        <Link
                          to="/company/our-advantages/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Our advantages
                        </Link>
                        <Link
                          to="/company/people-of-lentera/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          People Of Lentera
                        </Link>
                         <Link
                          to="/company/our-brand/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Our Brand
                        </Link>
                        {/* <Link
                          to="/our-values"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Our brand
                        // </Link> 
                    <a
  href="https://blog.lentera.in/"
  target="_blank"
  rel="noopener noreferrer"
  className="block px-4 py-2 text-xs hover:bg-gray-100"
  onClick={() => setIsMobileMenuOpen(false)}
>
  Blogs
</a>

                        {/* <Link
                          to="/certifications"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Certifications
                        </Link> */}
                      <a
  href="https://www.lentera.in/contact-us/"
  target="_blank"
  rel="noopener noreferrer"
  className="block px-4 py-2 text-xs hover:bg-gray-100"
  onClick={() => setIsMobileMenuOpen(false)}
>
  Support us
</a>

                      </div>
                    )}
                  </div>
                  <Link
                    to="/Contact/"
                    className="block py-2 text-sm hover:bg-gray-100"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Contact us
                  </Link>
                  {/* <button className="flex items-center gap-2 py-2 text-sm font-medium text-gray-700">
                    <img
                      src={ind}
                      alt="India Flag"
                      className="h-4 w-4 rounded-full"
                    />
                    India (English)
                    <ChevronDown className="h-4 w-4" />
                  </button> */}
          <button
                 onClick={handleClick}
  className="block py-2 text-sm font-semibold text-white bg-green-600 rounded-full hover:bg-green-700"
  // onClick={() => {
  //   const section = document.getElementById("contact-section");
  //   if (section) {
  //     section.scrollIntoView({ behavior: "smooth" });
  //   }
  // }}
>
  Get a Free Quote
</button>

                </nav>
              </div>
            )}
             <div className="bg-[#111215] text-white">
   {/* Footer Section */}
   <footer className="px-4 sm:px-8 md:px-12 pt-12 pb-4">
     {/* Newsletter Section */}
    <div className="w-full bg-[#111215] max-w-[1312px] mx-auto rounded-[24px] md:rounded-[48px] px-4 sm:px-8 md:px-12 py-8 md:py-12 shadow-[0_25px_80px_0_rgba(0,0,0,0.05)] flex flex-col gap-10">
            {/* Top newsletter */}
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 w-full">
              {/* Left Side */}
              <div className="flex items-start md:items-center gap-4 md:gap-6">
                <img src={news} alt="newsletter" className="w-12 h-12 md:w-[80px] md:h-[80px]" />
                <h2 className="text-xl md:text-[28px] font-bold leading-tight">
                  Join our newsletter to <br className="hidden md:block" />
                  keep up to date with us!
                </h2>
              </div>

              <div className="flex flex-col items-center gap-4 w-full sm:w-[335px]">
                {/* Newsletter input */}
                <div
                  className="flex items-center bg-[#111215] border border-[#333] px-4 py-3 sm:px-6 sm:py-4 w-full"
                  style={{ borderRadius: "6px" }}
                >
                  <img src={user} alt="user icon" className="w-5 h-5 mr-3" />
                  <input
                    type="email"
                    value={submail}
                    onChange={(e) => setSubmail(e.target.value)}
                    placeholder="Enter your email"
                    className="bg-transparent outline-none text-white placeholder-gray-400 w-full text-sm"
                  />
                </div>


                {/* Captcha line (canvas + refresh + input + subscribe button) */}
                {/* Outer wrapper to center the row */}
                <div className="w-full flex justify-center">
                  <div className="flex items-center gap-3">
                    {/* Captcha canvas */}
                    <div className="captcha-box">
                      <canvas
                        ref={newsletterCanvasRef}
                        id="newsletterCaptchaCanvas"
                        width={60}
                        height={40}
                        style={{ borderRadius: "6px", overflow: "hidden" }} // Optional inline for extra assurance
                      />
                    </div>

                    {/* Refresh button */}
                    <button
                      onClick={handleReload}
                      style={{
                        background: "#07862B ",
                        color: "#fff",
                        border: "none",
                        padding: "6px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="23 4 23 10 17 10"></polyline>
                        <polyline points="1 20 1 14 7 14"></polyline>
                        <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                      </svg>
                    </button>

                    {/* Captcha input */}
                    <input
                      type="text"
                      placeholder="Enter captcha"
                      value={newsletterUserCaptcha}
                      onChange={(e) => setNewsletterUserCaptcha(e.target.value)}
                      className="captcha-input"
                    />

                    {/* Subscribe button */}
                    <button className="subscribe-button" onClick={handleSubscribe}>
                      Subscribe
                    </button>
                  </div>
                </div>

                <style>{`
  .captcha-box {
    width: 60px !important;
    height: 35px !important;
    border-radius: 6px !important;
    overflow: hidden !important;
    color :131519;
    background-color: #fff !important;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
 
  .captcha-input {
    padding: 11px 8px !important;
    border-radius: 6px !important;
    border: 1px solid #ccc !important;
    outline: none !important;
    width: 100px !important;
    background: #131519 !important;
    color: #fff !important;
    font-size: 10px !important;
  }
 
  .subscribe-button {
    padding: 10px 16px !important;
    border-radius: 8px !important;
    border: none !important;
    background: #07862B !important;
    color: #fff !important;
    font-weight: bold !important;
    font-size: 13px !important;
    cursor: pointer !important;
    white-space: nowrap !important;
  }
 
  @media(max-width:480px){
    .captcha-input { width: 70px !important; font-size: 12px !important; }
    .subscribe-button { padding: 8px 12px !important; font-size: 12px !important; }
  }
`}</style>

              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-700 w-full" />

            {/* Main Footer Content */}
            <div className="flex flex-col lg:flex-row flex-wrap justify-between items-start w-full gap-8 text-[16px]">
              {/* Company Info */}
              <div className="w-full lg:w-[30%]">
                <a href="/" aria-label="Lentera Home">
                  <img src={nlen} alt="Lentera logo" className="mb-6" />
                </a>
                <p className="text-[#d4d4d4] leading-relaxed">
                  We are highly experienced in offering software development, mobile
                  application development, software consulting and project management
                  delivery.
                </p>
                {/* Social Icons */}
                <div className="flex gap-4 mt-6 flex-wrap">
                  <a href="https://www.instagram.com/lenteratechnologies/?hl=en" target="_blank" rel="noopener noreferrer">
                    <img src={inst} alt="Instagram" className="w-8 h-8" />
                  </a>
                  <a href="https://www.facebook.com/lenteratechnologies/?ref=pages_you_manage" target="_blank" rel="noopener noreferrer">
                    <img src={face} alt="Facebook" className="w-8 h-8" />
                  </a>
                  <a href="https://www.youtube.com/@lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={you} alt="YouTube" className="w-8 h-8" />
                  </a>
                  <a href="https://in.linkedin.com/company/lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={lin} alt="LinkedIn" className="w-8 h-8" />
                  </a>
                  <a href="https://x.com/lenteratech" target="_blank" rel="noopener noreferrer">
                    <img src={twi} alt="X" className="w-8 h-8" />
                  </a>
                </div>

              </div>

              {/* Services */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">OUR SERVICES</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><a href="/services/ai-services/" className="hover:text-white">AI services</a></li>
                  <li><a href="/services/web-development/" className="hover:text-white">Web development</a></li>
                  <li><a href="/services/mobile-app-development/" className="hover:text-white">Mobile app development</a></li>
                  <li><a href="/services/software-consulting/" className="hover:text-white">Software consulting</a></li>
                  <li><a href="/services/custom-development/" className="hover:text-white">Custom consulting</a></li>
                  <li><a href="/services/third-party-integration/" className="hover:text-white">Third party integration</a></li>
                  <li><a href="/services/enterprise-application/" className="hover:text-white">Enterprise Application</a></li>
                </ul>
              </div>


              {/* Insights */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">INSIGHTS</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><a href="https://blog.lentera.in/" className="hover:text-white">Blog</a></li>
                  <li><a href="https://www.lentera.in/careers/" className="hover:text-white">Careers</a></li>
                  <li><a href="https://blog.lentera.in/" className="hover:text-white">News</a></li>
                </ul>
              </div>

              {/* Contact */}
              <div className="w-full md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">CONTACT US</h4>
                <div className="flex items-start gap-3 mb-3">
                  <img src={phone} alt="phone" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Phone number</p>
                    <a href="tel:+914448563345" className="text-white font-medium text-sm hover:underline">
                      +91-44-4856-3345
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3 mb-3">
                  <img src={mail} alt="email" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Email address</p>
                    <a href="mailto:info@lenteratech.com" className="text-white font-medium text-sm hover:underline">
                      info@lenteratech.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <img src={loc} alt="location" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Location</p>
                    <a
                      href="https://www.google.com/maps?q=G1,+Plot+No+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white font-medium text-sm hover:underline block"
                    >
                      G1, Plot No, 824 and 826, 3rd<br />
                      Main Rd, Ram Nagar South,<br />
                      Madipakkam, Chennai,<br />
                      Tamil Nadu 600091
                    </a>
                  </div>
                </div>


              </div>
            </div>
          </div>
   </footer>
 
   {/* Bottom Section */}
   <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex flex-col md:flex-row justify-between items-center gap-2 py-4 px-4 sm:px-6 md:px-12 text-center md:text-left">
     <p>© 2025  Lentera Technologies Pvt Ltd. All rights reserved.</p>
     <div className="flex flex-wrap gap-4 justify-center md:justify-end">
       <a href="/terms-condition/" className="hover:underline">Terms and conditions</a>
       <a href="/privacy-policy/" className="hover:underline">Privacy Policy</a>
       <a href="/cookie-policy/" className="hover:underline">Cookies Policy</a>
       <a href="/copyright-information/" className="hover:underline">Copyright information</a>
     </div>
   </div>
 </div>
    </>
  );
}
